// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3-sO6","delete":"styles_delete__1Ao_6","update":"styles_update__ptrm9","add":"styles_add__NoUX7"};